/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';
import lodash from 'lodash';
import moment from 'moment';
import qs from 'qs';

// initial state
const state = {
  baseApiURL: '/api/sales/hearing-aids',
  initialValues: null,
  contents: {
    name: '',
    business_id: 0,
    location_id: 0,
    totals: [],
    totalsByVendor: [],
    totalsByMonth: [],
    totalsByVendorByMonth: [],
    locations: [],
    businesses: [],
    mixVendor: [],
    mixTier: [],
    mixProducts: [],
    statsNational: [],
  },
  contentsTemplate: {
    name: '',
    business_id: 0,
    location_id: 0,
    totals: [],
    totalsByVendor: [],
    totalsByMonth: [],
    totalsByVendorByMonth: [],
    locations: [],
    businesses: [],
    mixVendor: [],
    mixTier: [],
    mixProducts: [],
    statsNational: [],
  },
  filters: {
    dateFrom: null,
    dateTo: null,
    vendor: [],
    tier: [],
    product: [],
  },
  filtersTemplate: {
    dateFrom: null,
    dateTo: null,
    vendor: [],
    tier: [],
    product: [],
  },
  filtersLists: {
    dateList: [],
    disabledRange: null,
    productsList: [],
    vendorsList: [
      {
        label: 'Oticon',
        value: 'Oticon',
      },
      {
        label: 'Phonak',
        value: 'Phonak',
      },
      {
        label: 'Resound',
        value: 'Resound',
      },
      {
        label: 'Sonic',
        value: 'Sonic',
      },
      {
        label: 'Signia',
        value: 'Signia',
      },
      {
        label: 'Starkey',
        value: 'Starkey',
      },
      {
        label: 'Unitron',
        value: 'Unitron',
      },
      {
        label: 'Widex',
        value: 'Widex',
      },
    ],
    tiersList: [
      {
        label: 'Premium',
        value: 'Premium',
      },
      {
        label: 'Advanced',
        value: 'Advanced',
      },
      {
        label: 'Basic',
        value: 'Basic',
      },
      {
        label: 'Entry',
        value: 'Entry',
      },
      {
        label: 'Access',
        value: 'Access',
      },
      {
        label: 'CROS',
        value: 'CROS',
      },
      {
        label: 'OTC',
        value: 'OTC',
      },
    ],
  },
  dateFrom: null,
  dateTo: null,
  filtersListsTemplate: {
    dateList: [],
    disabledRange: null,
    productsList: [],
    vendorsList: [
      {
        label: 'Oticon',
        value: 'Oticon',
      },
      {
        label: 'Phonak',
        value: 'Phonak',
      },
      {
        label: 'Resound',
        value: 'Resound',
      },
      {
        label: 'Sonic',
        value: 'Sonic',
      },
      {
        label: 'Signia',
        value: 'Signia',
      },
      {
        label: 'Starkey',
        value: 'Starkey',
      },
      {
        label: 'Unitron',
        value: 'Unitron',
      },
      {
        label: 'Widex',
        value: 'Widex',
      },
    ],
    tiersList: [
      {
        label: 'Premium',
        value: 'Premium',
      },
      {
        label: 'Advanced',
        value: 'Advanced',
      },
      {
        label: 'Basic',
        value: 'Basic',
      },
      {
        label: 'Entry',
        value: 'Entry',
      },
      {
        label: 'CROS',
        value: 'CROS',
      },
    ],
  },
  sectionsInReport: [],
  filtersChanged: false,
  loaders: {
    dashboardData: true,
    mixVendor: false,
    mixTier: false,
    filters: false,
    sections: false,
    totals: false,
    totalsByVendor: false,
    totalsByMonth: false,
    totalsByVendorByMonth: false,
    totalsByVendorByMonthOneRow: false,
    locations: false,
    businesses: false,
    statsNational: false,
  },
  initializers: {
    initialLoad: false,
    dateList: false,
    initialCardLoaded: false,
  },
  // ...window.INITIAL_STATE.purchaseActivity,
};

// getters
const getters = {
  cancelToken: (state, getters, rootState) => rootState.main.cancelToken,
  baseApiURL: (state) => state.baseApiURL,
  initialValues: (state) => state.initialValues,
  contents: (state) => state.contents,
  dateFrom: (state) => state.dateFrom,
  dateTo: (state) => state.dateTo,
  filters: (state) => ({
    ...state.filters,
    dateFrom: moment(state.dateFrom).format('YYYY-MM-01'),
    dateTo: moment(state.dateTo).format('YYYY-MM-01'),
  }),
  sectionsInReport: (state) => state.sectionsInReport,
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
  filtersLists: (state) => state.filtersLists,
  productsList: (state) => state.filtersLists.productsList,
  vendorsList: (state) => state.filtersLists.vendorsList,
  tiersList: (state) => state.filtersLists.tiersList,
  dateList: (state) => state.filtersLists.dateList,
  locations: (state) => state.contents.locations,
  businesses: (state) => state.contents.businesses,
  disabledRangeFrom: (state, getters) => ({
    to: moment(getters.dateList[getters.dateList.length - 1]).toDate(),
    from: state.dateTo ? moment(state.dateTo).toDate() : moment(getters.dateList[0]).endOf('month').toDate(),
  }),
  disabledRangeTo: (state, getters) => ({
    to: state.dateFrom ? moment(state.dateFrom).toDate() : moment(getters.dateList[getters.dateList.length - 1]).toDate(),
    from: getters.dateList.length > 0 ? moment(getters.dateList[0]).endOf('month').toDate() : moment().endOf('month').toDate(),
  }),
  filterMonths: (state, getters) => Math.abs(moment(getters.filters.dateFrom).diff(moment(getters.filters.dateTo), 'months', true)),
  apiFilters: (state, getters) => ({
    dateFrom: moment(getters.filters.dateFrom).format('YYYY-MM-01'),
    dateTo: moment(getters.filters.dateTo).format('YYYY-MM-01'),
    filters: {
      vendor: getters.filters.vendor,
      tier: getters.filters.tier,
      product: getters.filters.product,
    },
  }),
  apiFilterString: (state, getters) => qs.stringify(getters.apiFilters, { arrayFormat: 'brackets' }),
  displayedSections: (state, getters) => lodash.filter(getters.sectionsInReport, (section) => getters[`display${section.replace(' ', '')}`]),
  displayTotals: (state) => !lodash.isEmpty(state.contents.totals),
  displayVendors: (state) => !lodash.isEmpty(state.contents.totalsByVendor),
  displayStats: (state) => !lodash.isEmpty(state.contents.statsNational),
  displayLocationSummary: (state) => (!lodash.isEmpty(state.contents.locations) && state.contents.locations.length > 1),
  displayLocations: (state) => (!lodash.isEmpty(state.contents.locations) && state.contents.locations.length > 1),
  displayPractices: (state) => (!lodash.isEmpty(state.contents.businesses) && state.contents.businesses.length > 1),
  loadingSections: (state) => lodash.chain([
    state.loaders.totals,
    state.loaders.vendors,
    state.loaders.statsNational,
    state.loaders.locations,
    state.loaders.businesses,
  ]).compact().value().length > 0,
  filtersChanged: (state) => state.filtersChanged,
  globalLoading: (state, getters, rootState) => rootState.main.globalLoading,
};

// actions
const actions = {
  async setPurchaseActivityCardDefaults({ commit, dispatch }) {
    commit('TOGGLE_INITIALIZED', { key: 'initialCardLoaded', value: false });
    await dispatch('getDateList');
    commit('TOGGLE_INITIALIZED', { key: 'initialCardLoaded', value: true });
    commit('TOGGLE_LOADING', { key: 'dashboardData', value: false });
  },
  loadMixVendor({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'mixVendor', value: true });
    return axios.get(`/api/sales/hearing-aids/member/mixVendor/?${getters.apiFilterString}`)
      .then((response) => {
        commit('SET_CONTENTS', { key: 'mixVendor', value: lodash.sortBy(response.data, (vendor) => parseInt(vendor.units, 10)).reverse() });
        commit('TOGGLE_LOADING', { key: 'mixVendor', value: false });
      });
  },

  loadMixTier({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'mixTier', value: true });
    return axios.get(`/api/sales/hearing-aids/member/mixTier/?${getters.apiFilterString}`)
      .then((response) => {
        commit('SET_CONTENTS', { key: 'mixTier', value: lodash.sortBy(response.data, (tier) => parseInt(tier.units, 10)).reverse() });
        commit('TOGGLE_LOADING', { key: 'mixTier', value: false });
      });
  },

  purchaseActivityCardFiltersUpdated({ dispatch }) {
    dispatch('loadMixVendor');
    dispatch('loadMixTier');
  },

  /**
   *  Fetches a list of dates that represents the range of sales data.
   *  For example: The first date in the list might be '2018-04-01' and the
   *  last date in the list might be '2014-04-01' representing the range of sales data.
   */
  getDateList({ commit, state, getters }) {
    return axios.get(`${state.baseApiURL}/filter/salesMonths/`)
      .then(({ data }) => {
        commit('SET_FILTER_LIST', { key: 'dateList', value: data });
        if (!(state.filters.dateFrom && state.filtersLists.dateList.includes(state.filters.dateFrom))) {
          commit('SET_PROPERTY', {
            key: 'dateFrom',
            value: moment(state.filtersLists.dateList[0]).toDate(),
          });
        }
        if (!(state.filters.dateTo && state.filtersLists.dateList.includes(state.filters.dateTo))) {
          commit('SET_PROPERTY', {
            key: 'dateTo',
            value: moment(state.filtersLists.dateList[0]).toDate(),
          });
        }
        commit('SET_FILTER_LIST', {
          key: 'disabledRange',
          value: {
            to: moment(state.filtersLists.dateList[state.filtersLists.dateList.length - 1]).toDate(),
            from: moment(state.filtersLists.dateList[0]).endOf('month').toDate(),
          },
        });
        commit('TOGGLE_INITIALIZED', { key: 'dateList', value: true });
      }).catch((thrown) => {});
  },

  /**
   *  Get list of Products
   */
  getProducts({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'products', value: true });
    commit('SET_FILTER_LIST', { key: 'productsList', value: [] });
    return axios.get(`${state.baseApiURL}/filter/products/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token },)
      .then((response) => {
        commit('SET_FILTER_LIST', { key: 'productsList', value: response.data });
        commit('TOGGLE_LOADING', { key: 'products', value: false });
      }).catch((thrown) => {});
  },

  getData({ commit, dispatch }) {
    commit('TOGGLE_LOADING', { key: 'sections', value: true });
    commit('SET_PROPERTY', { key: 'filtersChanged', value: false });
    dispatch('getTotals');
    dispatch('getStatsNational');
    dispatch('getTotalsByVendor');
    dispatch('getLocations');
    dispatch('getPractices');
    commit('TOGGLE_INITIALIZED', { key: 'initialLoad', value: true });
  },

  getLocations({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'locations', value: true });
    return axios.get(`${state.baseApiURL}/member/locations/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        const data = response.data.map((locationTotals) => {
          // Create new Sales Store
          const locationData = {
            ...state.contentsTemplate,
            name: locationTotals.location_name,
            location_id: locationTotals.location_id,
          };

          // Unset that general data
          delete locationTotals.member_name;
          delete locationTotals.location_name;
          delete locationTotals.location_id;
          delete locationTotals.business_id;

          // Assign the remaining data to the totals for this location.
          locationData.totals = locationTotals;
          return locationData;
        });

        commit('SET_CONTENTS', { key: 'locations', value: data });
        commit('TOGGLE_LOADING', { key: 'locations', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  /**
   *
   */
  getPractices({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'businesses', value: true });
    return axios.get(`${state.baseApiURL}/member/members/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        const data = response.data.map((businessTotals) => {
          // Create new Sales Store
          const businessData = {
            ...state.contentsTemplate,
            name: businessTotals.member_name,
            business_id: businessTotals.business_id,
          };

          // Unset that general data
          delete businessTotals.member_name;
          delete businessTotals.business_id;

          // Assign the remaining data to the totals for this business.
          businessData.totals = businessTotals;
          return businessData;
        });
        commit('SET_CONTENTS', { key: 'businesses', value: data });
        commit('TOGGLE_LOADING', { key: 'businesses', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotals({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'totals', value: true });
    return axios.get(`${state.baseApiURL}/member/totals/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totals', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totals', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotalsByVendor({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'totalsByVendor', value: true });
    return axios.get(`${state.baseApiURL}/member/totalsByVendor/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totalsByVendor', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totalsByVendor', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotalsByVendorByMonth({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonth', value: true });
    return axios.get(`${state.baseApiURL}/member/totalsByVendorByMonth/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totalsByVendorByMonth', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonth', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotalsByVendorByMonthOneRow({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonthOneRow', value: true });
    return axios.get(`${state.baseApiURL}/member/totalsByVendorByMonthOneRow/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totalsByVendorByMonthOneRow', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonthOneRow', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getStatsNational({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'statsNational', value: true });
    return axios.get(`${state.baseApiURL}/member/statsNational/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        const computedStats = {
          ...response.data[0],
          physicians: lodash.chain(response.data).map('physicians').sumBy((stat) => parseFloat(stat)).value(),
          audiologists: lodash.chain(response.data).map('audiologists').sumBy((stat) => parseFloat(stat)).value(),
          avg_revenue: lodash.chain(response.data).map('avg_revenue').sumBy((stat) => parseFloat(stat)).value(),
          avg_units: lodash.chain(response.data).map('avg_units').sumBy((stat) => parseFloat(stat)).value(),
        };
        commit('SET_CONTENTS', {
          key: 'statsNational',
          value: {
            ...computedStats,
            revenue_per_audiologist: Math.round(computedStats.avg_revenue / (computedStats.audiologists || 1)),
            units_per_audiologist: Math.round(computedStats.avg_units / (computedStats.audiologists || 1)),
            asp: Math.round(computedStats.avg_revenue / (computedStats.avg_units || 1)),
          },
        });
        commit('TOGGLE_LOADING', { key: 'statsNational', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },
  downloadTransactions({ dispatch, getters }, payload) {
    // Modify filters to set content type to blob.
    // Turn on loading animation
    dispatch('main/setProperty', { key: 'globalLoading', value: true }, { root: true });

    return axios.get(`${state.baseApiURL}/member/transactions/csv/?${qs.stringify(payload, { arrayFormat: 'brackets' })}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        dispatch('main/setProperty', { key: 'globalLoading', value: false }, { root: true });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data.csv');
        document.body.appendChild(link);
        link.click();
      }).catch((thrown) => {});
  },
  async cancelAjax({ dispatch }) {
    await dispatch('main/cancelAjax', null, { root: true });
    return;
  },
  resetStore({ commit, state, getters }) {
    commit('SET_PROPERTY', { key: 'contents', value: state.contentsTemplate });
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
  setContents({ commit }, payload) {
    commit('SET_CONTENTS', payload);
  },
  setFilter({ commit }, payload) {
    commit('SET_FILTER', payload);
  },
  setInitializer({ commit }, payload) {
    commit('TOGGLE_INITIALIZED', payload);
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    if (payload.key === 'dateFrom' || payload.key === 'dateTo') {
      state.filtersChanged = true;
    }
    state[payload.key] = payload.value;
  },
  SET_OBJECT_PROPERTY(state, payload) {
    state[payload.object][payload.key] = payload.value;
  },
  SET_CONTENTS(state, payload) {
    state.contents[payload.key] = payload.value;
  },
  SET_FILTER(state, payload) {
    if (state.initializers.initialLoad) {
      state.filtersChanged = true;
      state.contents = state.contentsTemplate;
    }
    state.filters[payload.key] = payload.value;
  },
  SET_FILTER_LIST(state, payload) {
    state.filtersLists[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  TOGGLE_INITIALIZED(state, payload) {
    state.initializers[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
